import { render, staticRenderFns } from "./EmptySpace.vue?vue&type=template&id=219964d8&scoped=true"
import script from "./EmptySpace.vue?vue&type=script&lang=js"
export * from "./EmptySpace.vue?vue&type=script&lang=js"
import style0 from "./EmptySpace.vue?vue&type=style&index=0&id=219964d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219964d8",
  null
  
)

export default component.exports